import { gql } from '@apollo/client';

export const UNSUBSCRIBE_EMAIL = gql`
  mutation UnsubscribeEmail(
    $email: String!
    $note: String
  ) {
    unsubscribeEmail(
      email: $email
      note: $note
    ) {
      errors { path, message }
    }
  }
`;
